type Outcome = 'success' | 'cancelled' | 'failed';
let reporter: ((props: Record<string, string>) => void) | undefined;

export function setAutocompleteTelemetryReporter(next: (props: Record<string, string>) => void): void {
  reporter = next;
}

export function reportAutocompleteRequest(outcome: Outcome, durationMs: number): void {
  try {
    reporter?.({ outcome, duration_ms: String(Math.min(999_999, Math.max(0, Math.round(durationMs)))) });
  } catch {
    // A telemetry failure must not interrupt search.
  }
}
